// extracted by mini-css-extract-plugin
export default {"contentContainer":"StyledDialog_contentContainer__s6zDW","iconContainer":"StyledDialog_iconContainer__wh8+E","closeIcon":"StyledDialog_closeIcon__wa0jn"};